import React from 'react';

// Page title + optional one-line state summary + primary actions. The app a page works
// on is shown (and switched) in the shell's top bar, not here.
// Subtitles should carry real, current state (never repeat the title).
const PageHeader = ({ title, subtitle, actions }) => (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="min-w-0">
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-600">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </div>
);

export default PageHeader;
